<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')" allow-clear>
                  <a-select-option :value="0">Pending Review</a-select-option>
                  <a-select-option :value="1">Approved</a-select-option>
                  <a-select-option :value="2">Rejected</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="contactPhone">
                <a-input v-model="queryParam.contactPhone" :maxLength="32" :placeholder="$t('请输入手机号')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('邮箱')" prop="email">
                <a-input v-model="queryParam.email" :maxLength="32" :placeholder="$t('请输入邮箱')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleBatchPass" v-hasPermi="['task:unionaffiliateapply:edit']">
          {{ $t('审核通过') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleBatchRejectShow" v-hasPermi="['task:unionaffiliateapply:edit']">
          {{ $t('审核拒绝') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['union:unionaffiliateapply:export']">
          <a-icon type="download" />
          {{ $t('导出数据') }}
        </a-button>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps:getCheckboxProps }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status===0">Pending Review</span>
          <span v-else-if="record.status===1">Approved</span>
          <span v-else-if="record.status===2">Rejected</span>
        </span>
        <span slot="submitTime" slot-scope="text, record">
          {{ parseTime(record.submitTime) }}
        </span>
        <span slot="auditTime" slot-scope="text, record">
          {{ parseTime(record.auditTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleView(record)" v-hasPermi="['union:unionaffiliateapply:edit']">
            {{ $t('查看详情') }}
          </a>
          <a-divider v-if="record.status === 0" type="vertical" v-hasPermi="['union:unionaffiliateapply:edit']" />
          <a v-if="record.status === 0" @click="handleBatchPass(record)" v-hasPermi="['union:unionaffiliateapply:edit']">
            {{ $t('审核通过') }}
          </a>
          <a-divider v-if="record.status === 0" type="vertical" v-hasPermi="['union:unionaffiliateapply:edit']" />
          <a v-if="record.status === 0" @click="handleBatchRejectShow(record)" v-hasPermi="['union:unionaffiliateapply:edit']">
            {{ $t('审核拒绝') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleBatchReject"
      @cancel="rejectModalVisible = false"
    />
  </page-header-wrapper>
</template>

<script>
import { pageUnionAffiliateApply, delUnionAffiliateApply, batchPassUnionAffiliateApply, batchRejectUnionAffiliateApply } from '@/api/union/unionAffiliateApply'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'
import RejectModal from '@/components/RejectModal/index.vue'

export default {
  name: 'UnionAffiliateApply',
  components: {
    RejectModal,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        userId: undefined,
        name: undefined,
        contactPhone: undefined,
        email: undefined,
        instagram: undefined,
        tiktok: undefined,
        youtube: undefined,
        facebook: undefined,
        pinterest: undefined,
        country: undefined,
        city: undefined,
        status: undefined,
        processRemark: undefined,
        auditor: undefined,
        auditTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('姓名'),
          dataIndex: 'name',
          ellipsis: true,
          width: '120px',
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('联系方式'),
          dataIndex: 'contactPhone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('邮箱联系方式'),
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('网站'),
          dataIndex: 'website',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Instagram',
          dataIndex: 'instagram',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'TikTok',
          dataIndex: 'tiktok',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'YouTube',
          dataIndex: 'youtube',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Facebook',
          dataIndex: 'facebook',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Pinterest',
          dataIndex: 'pinterest',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('提交时间'),
          dataIndex: 'submitTime',
          scopedSlots: { customRender: 'submitTime' },
          ellipsis: true,
          align: 'center',
          sorter: true // 开启服务端排序
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('处理备注'),
          dataIndex: 'processRemark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '250px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      rejectModalVisible: false
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    handleSelectExport() {
      var that = this
      let queryParam = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据'),
        okText: this.$t('确认'),
        cancelText: this.$t('取消'),
        onOk() {
          that.download('union/union/affiliate/apply/export', that.queryParam, `union_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    /** 查询联盟申请列表 */
    getList() {
      this.loading = true
      pageUnionAffiliateApply(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        userId: undefined,
        name: undefined,
        contactPhone: undefined,
        email: undefined,
        instagram: undefined,
        tiktok: undefined,
        youtube: undefined,
        facebook: undefined,
        pinterest: undefined,
        country: undefined,
        city: undefined,
        status: undefined,
        processRemark: undefined,
        auditor: undefined,
        auditTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'submitTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUnionAffiliateApply(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('union/union/affiliate/apply/export',
            that.queryParam
            , `unionAffilateAplly_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleBatchPass(row) {
      var that = this
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认通过选中数据'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return batchPassUnionAffiliateApply(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('审核成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleBatchRejectShow(row) {
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      var that = this
      this.$confirm({
        title: this.$t('确认拒绝选中数据'),
        onOk() {
          that.rejectModalVisible = true
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
          that.rejectModalVisible = false
        }
      })
    },
    handleBatchReject(reason) {
      var that = this
      const data = []
      that.ids.map(id => data.push(id))
      return batchRejectUnionAffiliateApply({ ids: data, reason: reason })
        .then(() => {
          that.onSelectChange([], [])
          that.getList()
          const message = that.$t('拒绝成功')
          that.$message.success(
            message,
            3
          )
          this.rejectModalVisible = false
        }).catch(() => {
          this.rejectModalVisible = false
        })
    },
    getCheckboxProps: record => ({
      props: {
        disabled: record.status !== 0, // Column configuration not to be checked
        name: record.name
      }
    })
  }
}
</script>
